import { useEffect } from 'react';
import Search from './Search';
import { isEmptyData } from '../../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { getRecentList, getSavedList } from '../../../store/reducers/location';
import useGoogleMapsLoader from '../../../hook/useGoogleMapsLoader';

const DeliveryLocation = (props) => {
  const { isLoaded: isLoadedGoogleMaps } = useGoogleMapsLoader();
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);

	useEffect(() => {
		if (isEmptyData(user?.token)) return;
		dispatch(getRecentList());
		dispatch(getSavedList());
	}, [user?.token]);

  if (!isLoadedGoogleMaps) return null;

	return (
		<div className='p-4 overflow-y-scroll'>
			<div className='text-base font-semibold text-gray-800 mb-4'>Pilih Lokasi</div>
			<Search {...props} />
		</div>
	);
};

export default DeliveryLocation;
